import { Button } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { forwardRef } from "react"

const MetaButton = forwardRef(({ icon, label, children, ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      py="1.5"
      px="4"
      size="md"
      fontWeight="normal"
      colorPalette="gray"
      variant="subtle"
      tabIndex="32767" // effectively ensuring we only tab into CohortMeta after everything else within focusable tree.
      h="auto"
      {...rest}
    >
      {!!icon && <Pathicon icon={icon} />}
      {label}
    </Button>
  )
})

export default MetaButton
